
import { useState, useEffect, useRef } from 'react';
import { Button } from '@mui/material';
import { useSearchParams } from "react-router-dom";
import { addDays, format } from 'date-fns';
import { usePost } from './../../apis/ApiRequests';
import ReaOnlyOutlinedInput from '../../components/input/ReaOnlyOutlinedInput';
import CustomConfirm from '../../components/confirm/CustomConfirm';
import { dateToString } from '../../utils/Library';
import CustomSnackBar from '../../components/alert/CustomSnackBar';
import { fishStyleList, lineList } from '../../Store';
import CustomSelect from '../../components/select/CustomSelect';
import NonInputOutlinedInput from '../../components/input/NonInputOutlinedInput';

const UnloadList = () => {
    
	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - 基本情報を設定
	//-----------------------------------------------
    const today          = format(addDays(new Date(), 0), 'yyyy-MM-dd');
    const [searchParams] = useSearchParams();
    const facilityCode   = searchParams.get("facilityCode");
    const userId         = searchParams.get("userId");
    const terminalNo     = searchParams.get("terminalNo");

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ entryDate,      setEntryDate      ] = useState(today);
    const [ requireMessage, setRequireMessage ] = useState('');
    const [ focusCell,      setFocusCell      ] = useState('');
    
	//-----------------------------------------------
    // initialize - 登録データのテンプレート
	//-----------------------------------------------
    const [registerData, setRegisterData] = useState({
        lineNo          : terminalNo,
        uniqueId        : '',
        entryDate       : '',
        senmei          : '',
        senmeiCode      : '',
        senmei          : '',
        gyoshuCode      : '',
        gyoshu          : '',
        kikakuCode      : '',
        kikaku          : '',
        fishMethodCode  : '',
        fishMethod      : '',
        kgKubun         : 1,
        nisugata        : 1,
        kgSuryo         : '0.00',
        yokiCode        : '',
        yoki            : '',
        suryo           : 1,
        mikomiFlag      : false,
        displayNo       : '',
        bidStatus       : 0,
        bidMode         : 0,
        danbeNo         : 0,
        unloadFlag      : 1
    });
	//-----------------------------------------------
    // initialize - UI Message
	//-----------------------------------------------
    const [messageState, setMessageState] = useState({
        snackBarTrue  : false,
        snackBarFalse : false,
        require       : false,
    });
	//-----------------------------------------------
    // initialize - useRef
	//-----------------------------------------------
    const effectRan     = useRef(false);
    const senmeiCodeRef = useRef();
    const senmeiRef     = useRef();
    const gyoshuCodeRef = useRef();
    const gyoshuRef     = useRef();
    const kikakuCodeRef = useRef();

	//===============================================
	// API
	//===============================================
	//-----------------------------------------------
    // API - getNextId / BidList
	//-----------------------------------------------
    const { response : getNextId_res, post : getNextId_post } = usePost();
    const getNextId = async () => {
        const postData = {
            'className'    : 'mch.models.table.BidList',
            'methodName'   : 'getNextId',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getNextId_post(postData);
    };
	//-----------------------------------------------
    // API - setData / BidList
	//-----------------------------------------------
    const { response : setData_res, post:setData_post } = usePost();
    const setData = async (targetData) => {
        const numericDate = dateToString(entryDate)
        const postData = {
            'className'       : 'mch.models.table.BidList',
            'methodName'      : 'setDataByBidder',
            'facilityCode'    : facilityCode,
            'userId'          : userId,
            'activeFlag'      : targetData.activeFlag,
            'userId'          : userId,
            'uniqueId'        : targetData.uniqueId,
            'entryDate'       : numericDate,
            'lineNo'          : targetData.lineNo,
            'senmei'          : targetData.senmei,
            'senmeiCode'      : targetData.senmeiCode,
            'senmei'          : targetData.senmei,
            'gyoshuCode'      : targetData.gyoshuCode,
            'gyoshu'          : targetData.gyoshu,
            'kikakuCode'      : targetData.kikakuCode ? targetData.kikakuCode : '0',
            'kikaku'          : targetData.kikaku ? targetData.kikaku : 'なし',
            'fishMethodCode'  : targetData.fishMethodCode,
            'fishMethod'      : targetData.fishMethod,
            'kgKubun'         : targetData.kgKubun,
            'nisugata'        : targetData.nisugata,
            'kgSuryo'         : targetData.kgSuryo,
            'suryo'           : targetData.suryo,
            'mikomiFlag'      : targetData.mikomiFlag ? 1 : 0,
            'displayNo'       : targetData.displayNo,
            'bidStatus'       : targetData.bidStatus,
            'bidMode'         : 0,
            'danbeNo'         : 0,
            'unloadFlag'      : 1
        }
        await setData_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.Ship
	//-----------------------------------------------
    const { response : getData_ship_res, post : getData_ship_post } = usePost();
    const getData_ship = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_ship_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.FishSpec
	//-----------------------------------------------
    const { response : getData_fishSpec_res, post : getData_fishSpec_post } = usePost();
    const getData_fishSpec = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.OriginalFishSpec',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_fishSpec_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.FishSpec
	//-----------------------------------------------
    const { response : updateTimesNum_res, post : updateTimesNum_post } = usePost();
    const updateTimesNum = async (gyoshuCode) => {
        const postData = {
            'className'    : 'mch.models.masta.FishSpec',
            'methodName'   : 'updateTimesNum',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : gyoshuCode,
            'activeFlag'   : 1
        }
        await updateTimesNum_post(postData);
    };
	//-----------------------------------------------
    // API - getData / masta.standard
	//-----------------------------------------------
    const { response : getData_standard_res, post : getData_standard_post } = usePost();
    const getData_standard = async (code) => {
        const postData = {
            'className'    : 'mch.models.masta.Standard',
            'methodName'   : 'getData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'code'         : code
        }
        await getData_standard_post(postData);
    };
    
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {
        // 初回マウント時のみ実行
        if (effectRan.current === false) {
            effectRan.current = true;

            senmeiCodeRef.current.focus();
            setFocusCell('senmeiCode');
        }
    },[]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (getNextId_res) {
            const targetData = { ...registerData, uniqueId: getNextId_res.uniqueId, activeFlag: 1 };
            const requireStatus = checkedRequire(); // 必須項目をチェックする
            if (requireStatus) {
                setData(targetData);
            } else {
                setMessageInfo('require', true);
            }
        }
    }, [getNextId_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(setData / bidList)
	//-----------------------------------------------
    useEffect(() => {
        if (setData_res) {
            if (setData_res.statusCode == 9) {
                setRequireMessage('落札済みのため変更できません');
                setMessageInfo('require', true);
            } else if (setData_res.statusCode == 1) {
                setRequireMessage('入札が開始されているため変更できません');
                setMessageInfo('require', true);
            } else if (setData_res.statusCode == 8) {
                setRequireMessage('開票中のため変更できません');
                setMessageInfo('require', true);
            } else {
                updateTimesNum(registerData.gyoshuCode); // 魚種の利用回数をカウントアップ
    
                setMessageInfo('confirm', false);
                setMessageInfo('snackBarTrue', true);
                    
                // 船名と魚種は記憶して初期化
                setRegisterData(prevSearchData => ({
                    ...prevSearchData,
                    uniqueId     : '',
                    kgSuryo      : '0.0',
                    gyoshuCode   : '',
                    gyoshu       : '',
                    kikakuCode   : '',
                    kikaku       : '',
                    kgKubun      : 1,
                    suryo        : 1,
                    mikomiFlag   : false,
                    bidStatus    : 0,
                    bidMode      : 0,
                    danbeNo      : 0,
                    unloadFlag   : 1
                }));
    
                // 魚種にフォーカス
                gyoshuCodeRef.current.focus();
                setFocusCell('gyoshuCode');
            }
        }
    }, [setData_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_ship)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_ship_res) {
            if (getData_ship_res.displayName) {
                handleChange('senmeiCode', getData_ship_res.code);
                handleChange('senmei', getData_ship_res.displayName);
            } else {
                handleChange('senmeiCode', '');
                handleChange('senmei', '');
                senmeiCodeRef.current.focus();
                setFocusCell('senmeiCode');
            }
        }
    }, [getData_ship_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_fishSpec)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_fishSpec_res) {
            if (getData_fishSpec_res.displayName) {
                handleChange('gyoshuCode', getData_fishSpec_res.code);
                handleChange('gyoshu', getData_fishSpec_res.displayName);
            } else {
                handleChange('gyoshuCode', '');
                handleChange('gyoshu', '');
                gyoshuCodeRef.current.focus();
                setFocusCell('gyoshuCode');
            }
        }
    }, [getData_fishSpec_res]);
	//-----------------------------------------------
    // useEffect - APIレスポンス(getData / masta_Standard)
	//-----------------------------------------------
    useEffect(() => {
        if (getData_standard_res) {
            if (getData_standard_res.displayName) {
                handleChange('kikakuCode', getData_standard_res.code);
                handleChange('kikaku', getData_standard_res.displayName);
            } else {
                handleChange('kikakuCode', '');
                handleChange('kikaku', '');
                kikakuCodeRef.current.focus();
                setFocusCell('kikakuCode');
            }
        }
    }, [getData_standard_res]);
    
	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - データの設定
	//-----------------------------------------------
    const handleChange = (name, value) => {
        setRegisterData(prevSearchData => ({
            ...prevSearchData,
            [name]: value,
        }));
    };
	//-----------------------------------------------
    // eventHandler - 新規ボタン
	//-----------------------------------------------
    const handleClick_new = () => {
        setRegisterData({
            uniqueId        : '',
            entryDate       : '',
            lineNo          : terminalNo,
            senmei          : '',
            senmeiCode      : '',
            senmei          : '',
            gyoshuCode      : '',
            gyoshu          : '',
            kgKubun         : 1,
            nisugata        : 1,
            kikakuCode      : '',
            kikaku          : '',
            fishMethodCode  : '',
            fishMethod      : '',
            kgSuryo         : '',
            mikomiFlag      : false,
            displayNo       : '',
            bidStatus       : 0,
            bidMode         : 0,
            danbeNo         : 0,
            unloadFlag      : 1
        });
        senmeiCodeRef.current.focus();
        setFocusCell('senmeiCode');
    };
	//-----------------------------------------------
    // eventHandler - キーボタンのクリック
	//-----------------------------------------------
    const handleKeyDown = (name, event) => {
        if (event.key === "Enter") {
            if (focusCell == 'senmeiCode') {
                handleChange('senmei', '');
                getData_ship(registerData.senmeiCode);
                gyoshuCodeRef.current.focus();
                setFocusCell('gyoshuCode');
            } else if (focusCell == 'gyoshuCode') {
                handleChange('gyoshu', '');
                getData_fishSpec(registerData.gyoshuCode);
                kikakuCodeRef.current.focus();
                setFocusCell('kikakuCode');
            } else if (focusCell == 'kikakuCode') {
                handleChange('kikaku', '');
                getData_standard(registerData.kikakuCode);
                senmeiCodeRef.current.focus();
                setFocusCell('senmeiCode');
            } else {}
        }
    };
	//-----------------------------------------------
    // eventHandler - 登録ボタン
	//-----------------------------------------------
    const handleClick_Register = async (activeFlag) => {
        const targetData = { ...registerData, activeFlag };
        // 新規の場合はuniqueIdを発行して登録処理を実行
        if (!targetData.uniqueId) {
            await getNextId();
        
        // 更新の場合は既存のuniqueIdに対して登録処理を実行
        } else {
            const requireStatus = checkedRequire(); // 必須項目をチェックする
            if (requireStatus) {
                await setData(targetData);
            } else {
                setMessageInfo('require', true);
            }
        }
    };
    
	//===============================================
	// Function
	//===============================================
	//-----------------------------------------------
	// Function - 必須項目をチェックする
	//-----------------------------------------------
    const checkedRequire = () => {
        const errorFields = [];
    
        //if (!uniqueId) errorFields.push('「伝票番号」')
        if (registerData.lineNo == 0) errorFields.push('「ラインNo」');
        if (!registerData.senmeiCode) errorFields.push('「荷主コード」');
        if (!registerData.senmei) errorFields.push('「荷主」');
        if (!registerData.gyoshuCode) errorFields.push('「品名コード」');
        if (!registerData.gyoshu) errorFields.push('「品名」');
    
        if (errorFields.length) {
            const text = errorFields.join('、') + 'が入力されていません';
            setRequireMessage(text);
            return false;  // エラーがある場合は false を返します
        }
        
        return true;  // エラーがない場合は true を返します
    }
    
	//===============================================
	// UI Message
	//===============================================
    const setMessageInfo = (target, state) => {
        setMessageState(prevSearchData => ({
            ...prevSearchData,
            [target]: state,
        }));
    };
    
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <div className='unloadList bodyContens'>
                <div style={{ marginRight : '0px', marginTop: '10px', display : 'flex' }}>
                    <div style={{margin: '0.1rem', width:'100%'}}>
                        <CustomSelect
                            id         = "bidList_lineNo"
                            label      = "ラインNo"
                            width      = "100%"
                            dataList   = {lineList} 
                            selectedId = {registerData.lineNo}
                            onChange   = {(e) => handleChange('lineNo', e.target.value)}
                        />
                    </div>
                </div>
                <div style={{ marginRight : '0px', marginTop: '5px', display : 'flex' }}>
                    <Button color="primary" size="large" variant="contained"
                        sx={{ margin: '0rem', width:'100px' }}
                        >荷主
                    </Button>
                    <NonInputOutlinedInput
                        type     = "text"
                        id       = "unloadList_senmeiCode"
                        label    = "コード"
                        inputRef = { senmeiCodeRef }
                        value    = { registerData.senmeiCode }
                        onClick  = {() => setFocusCell('senmeiCode')}
                        onChange= {(e) => handleChange('senmeiCode', e.target.value)}
                        onKeyDown= {(e) => handleKeyDown('senmeiCode', e)}
                        style    = {{ margin: '0.1rem', width: '100%', fontSize: '180px' }}
                    />
                </div>
                <div style={{ marginRight : '0px', marginTop: '10px', display : 'flex' }}>
                    <ReaOnlyOutlinedInput
                        type     = "text"
                        id       = "unloadList_senmei"
                        label    = "名称"
                        inputRef = { senmeiRef }
                        value    = { registerData.senmei }
                        onClick  = {() => setFocusCell('senmei')}
                        onChange = {(e) => handleChange('senmei', e.target.value)}
                        style={{ margin: '0.1rem', width: '100%', fontSize: '22px' }}
                    />
                </div>
                <div style={{ marginRight : '0px', marginTop: '7px', display : 'flex' }}>
                    <Button color="primary" size="large" variant="contained"
                        sx={{ margin: '0rem', width:'100px' }}
                        onClick={ handleChange }
                        >品名
                    </Button>
                    <NonInputOutlinedInput
                        type     = "text"
                        id       = "unloadList_gyoshuCode"
                        label    = "コード"
                        inputRef = { gyoshuCodeRef }
                        value    = { registerData.gyoshuCode }
                        onClick  = {() => setFocusCell('gyoshuCode')}
                        onChange = {(e) => handleChange('gyoshuCode', e.target.value)}
                        onKeyDown= {(e) => handleKeyDown('gyoshuCode', e)}
                        style={{ margin: '0.1rem', width: '100%' }}
                    />
                </div>
                <div style={{ marginRight : '0px', marginTop: '10px', display : 'flex' }}>
                    <ReaOnlyOutlinedInput
                        type     = "text"
                        id       = "unloadList_gyoshu"
                        label    = "名称"
                        inputRef = { gyoshuRef }
                        value    = { registerData.gyoshu }
                        onClick  = {() => setFocusCell('gyoshu')}
                        onChange = {(e) => handleChange('gyoshu', e.target.value)}
                        style={{ margin: '0rem', width: '100%' }}
                    />
                    <div style={{margin: '0.1rem', width:'30%'}}>
                        <CustomSelect
                            id         = "unloadList_fishStyle"
                            label      = "荷姿"
                            width      = "100%"
                            dataList   = {fishStyleList} 
                            selectedId = {registerData.nisugata}
                            onChange = {(e) => handleChange('nisugata', e.target.value)}
                        />
                    </div>
                </div>
                <div style={{ marginRight : '0px', marginTop: '10px', display : 'flex' }}>
                    <Button color="primary" size="large" variant="contained"
                        sx={{ margin: '0rem', width:'100px' }}
                        >規格
                    </Button>
                    <NonInputOutlinedInput
                        type     = "text"
                        id       = "unloadList_kikakuCode"
                        label    = "コード"
                        inputRef = { kikakuCodeRef }
                        value    = { registerData.kikakuCode }
                        onClick  = {() => setFocusCell('kikakuCode')}
                        onChange= {(e) => handleChange('kikakuCode', e.target.value)}
                        onKeyDown= {(e) => handleKeyDown('kikakuCode', e)}
                        style    = {{ margin: '0.1rem', width: '100%', fontSize: '180px' }}
                    />
                </div>
                <div style={{ marginRight : '0px', marginTop: '5px', display : 'flex' }}>
                    <ReaOnlyOutlinedInput
                        type     = "text"
                        id       = "unloadList_kikaku"
                        label    = "名称"
                        inputRef = { senmeiRef }
                        value    = { registerData.kikaku }
                        onClick  = {() => setFocusCell('kikaku')}
                        onChange = {(e) => handleChange('kikaku', e.target.value)}
                        style={{ margin: '0.1rem', width: '100%', fontSize: '22px' }}
                    />
                </div>
                <div style={{ marginRight : '0px', marginTop: '10px', display : 'flex' }}>
                    <Button
                        color   = "secondary"
                        size    = "large"
                        variant = "contained"
                        style   = {{ fontSize: '22px', height:'60px', width:'100%', color:'#fff', backgroundColor:'#ff7f50' }}
                        onClick = {() => handleClick_new()}
                        >
                        {'新規入力'}
                    </Button>
                    <Button
                        color   = "secondary"
                        size    = "large"
                        variant = "contained"
                        style   = {{ fontSize: '22px', height:'60px', width:'100%', marginLeft: '0.2rem', color:'#fff', backgroundColor:'#4A9DBC' }}
                        onClick = {() => handleClick_Register('1')}
                        >
                        {'登録'}
                    </Button>
                </div>
                <CustomSnackBar
                    open            = {messageState.snackBarTrue}
                    onClose         = {() => setMessageInfo('snackBarTrue', false)}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "登録しました"
                />
                <CustomSnackBar
                    open            = {messageState.snackBarFalse}
                    onClose         = {() => setMessageInfo('snackBarFalse', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = "登録に失敗しました"
                />
                <CustomSnackBar
                    open            = {messageState.require}
                    onClose         = {() => setMessageInfo('require', false)}
                    severity        = "error"
                    backgroundColor = "#db7093"
                    message         = {requireMessage}
                />
                <CustomConfirm
                    open      = {messageState.confirm}
                    onClose   = {() => setMessageInfo('confirm', false)}
                    onClickNG = {() => setMessageInfo('confirm', false)}
                    onClickOK = {() => handleClick_Register(0)}
                    message   = "指定データの削除を行います。よろしいですか？"
                />
            </div>
        </>
    )
}
export default UnloadList;
  